export default "__VITE_ASSET__DoiXk$To__"